//https://blog.csdn.net/lion888/article/details/52109101
//
/*
 *   Savitzky-Golay 5点1阶滤波  matlab:sgolay(1,5)
 *
 *   +0.600 +0.400 +0.200 -0.000 -0.200
 *   +0.400 +0.300 +0.200 +0.100 -0.000
 *   +0.200 +0.200 +0.200 +0.200 +0.200
 *   -0.000 +0.100 +0.200 +0.300 +0.400
 *   -0.200 -0.000 +0.200 +0.400 +0.600
 */
export const linearSmooth5 = (src) => {
  let out = [],
    l = src.length
  if (l < 5) {
    out = src.map(i => [i[0] , i[1]])
  } else {
    out[0] = [
      (3.0 * src[0][0] + 2.0 * src[1][0] + src[2][0] - src[4][0]) / 5.0,
      (3.0 * src[0][1] + 2.0 * src[1][1] + src[2][1] - src[4][1]) / 5.0
    ]

    out[1] = [
      (4.0 * src[0][0] + 3.0 * src[1][0] + 2 * src[2][0] + src[3][0]) / 10.0,
      (4.0 * src[0][1] + 3.0 * src[1][1] + 2 * src[2][1] + src[3][1]) / 10.0
    ]

    for (let i = 2; i <= l - 3; i++) {
      out[i] = [
        (src[i - 2][0] + src[i - 1][0] + src[i][0] + src[i + 1][0] + src[i + 2][0]) / 5.0,
        (src[i - 2][1] + src[i - 1][1] + src[i][1] + src[i + 1][1] + src[i + 2][1]) / 5.0
      ]
    }

    out[l - 2] = [
      (4.0 * src[l - 1][0] + 3.0 * src[l - 2][0] + 2 * src[l - 3][0] + src[l - 4][0]) / 10.0,
      (4.0 * src[l - 1][1] + 3.0 * src[l - 2][1] + 2 * src[l - 3][1] + src[l - 4][1]) / 10.0
    ]
    out[l - 1] = [
      (3.0 * src[l - 1][0] + 2.0 * src[l - 2][0] + src[l - 3][0] - src[l - 5][0]) / 5.0,
      (3.0 * src[l - 1][1] + 2.0 * src[l - 2][1] + src[l - 3][1] - src[l - 5][1]) / 5.0
    ]
  }

  return out;
}
